import { ref, unref, computed } from 'vue';

function getMemberProduct(product, selectedLatchkey, latchKeyProductIdsByGroup) {
  const latchkeyGroup = unref(latchKeyProductIdsByGroup)[unref(selectedLatchkey)] || [];
  const latchkeyMemberProductId = latchkeyGroup.length === 1 ? latchkeyGroup[0] : '';
  return unref(product).relationships.memberProductMap[unref(latchkeyMemberProductId)];
}

/**
 *
 * @param {import('vue').ComputedRef<Product>} product
 * @param {import('vue').WritableComputedRef<Color | null>} selectedColor
 * @param {import('vue').ComputedRef<string?>} selectedUpcId
 * @param {import('vue').ComputedRef<string>} selectedLatchkey
 * @param {import('vue').ComputedRef<Record<string, string[]>>} latchKeyProductIdsByGroup
 * @returns {import('vue').ComputedRef<Image[]>}
 */
export default function useImageLatchkey(product, selectedColor, selectedUpcId, selectedLatchkey, latchKeyProductIdsByGroup) {
  /** @type {import('vue').Ref<Image[]>} */
  const lastValidImages = ref([]); // TODO remove this image cache once mcom xapi migrates to bcom data

  const images = computed(() => {
    let result = [];

    const latchkeyProduct = unref(product).relationships.latchKeyToProductMap?.[selectedLatchkey.value];
    const upcMap = latchkeyProduct?.traits.traitsMaps?.upcMap || {};
    const selectedColorId = unref(selectedColor)?.id;
    const firstUpcKeyWithColor = Object.keys(upcMap).find((upcKey) => upcKey.includes(selectedColorId));
    const firstUpcIdWithColor = upcMap[firstUpcKeyWithColor];

    const upcIdSource = unref(selectedUpcId) || firstUpcIdWithColor;

    const upcProduct = unref(product).relationships.upcs[upcIdSource];
    const memberProduct = getMemberProduct(product, selectedLatchkey, latchKeyProductIdsByGroup);

    if (upcProduct) {
      result = upcProduct.imagery.images || [];
    } else if (memberProduct) {
      result = Object.values(unref(memberProduct).traits.colors?.colorMap || {}).find((c) => c.name === unref(selectedColor)?.name)?.imagery.images
      || unref(memberProduct).imagery?.images
      || unref(product).imagery.images
      || [];
    } else {
      result = Object.values(unref(product).traits.colors?.colorMap || {}).find((c) => c.name === unref(selectedColor)?.name)?.imagery.images
      || unref(product).imagery?.images
      || [];
    }

    if (result.length) {
      lastValidImages.value = result;
      return result;
    }

    return lastValidImages.value;
  });

  return images;
}
